const FAQ_LOADING = "FAQ_LOADING";
const FAQ_SUCCESS = "FAQ_SUCCESS";
const FAQ_ERROR = "FAQ_ERROR";

export {
    FAQ_LOADING,
    FAQ_ERROR,
    FAQ_SUCCESS,
};